<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-card bg-variant="light">

          <b-form-row @keyup.enter="load">

            <b-col cols="2" class="text-left">
              <lg-form-const-select label="Situação:" v-model="form.situacao" :options="optionsFilterSituacao"
                @change="load()" />
            </b-col>


            <lg-form-input v-model="form.descricao" label="Descrição:" cols="12" sm="4" md="4" />
            <b-col cols="2" class=" mt-2">
              <b-button id="localizar" class=" my-2" size="sm" style="height: 20px" pill variant="primary"
                @click="load()">
                <div class="btn-size-alinhamento">
                  <b-icon icon="search" /> &nbsp;
                </div>
                <b-tooltip target="localizar" title="Localizar"></b-tooltip>

              </b-button>
            </b-col>

            <b-col cols="2" class="text-right mt-2">
              <b-button class="my-2" size="sm" style="height: 20px" pill variant="primary" @click="mostrarModal">
                <div class="btn-size-alinhamento" id="adicionarTipoProblema">
                  <b-icon scale="1" icon="plus" /> &nbsp;
                </div>
                <b-tooltip target="adicionarTipoProblema" title="Adicionar novo..."></b-tooltip>

              </b-button>
            </b-col>
          </b-form-row>
        </b-card>
        <b-card bg-variant="light">
          <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
            :hover="true" show-empty @row-dblclicked="selectItem" >

            <template #empty>
              <p>Nenhum registro encontrado</p>
            </template>


            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template v-slot:cell(situacao)="{ item }">
              <b-form-checkbox v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch
                size="lg" :value="1" :unchecked-value="0" />
            </template>
            <template v-slot:cell(action)="row">
              <b-button :id="row.index + 'edit-buttonTipoProblema'" class="my-2" size="sm" pill variant="primary"
                @click="editar(row.item)">
                <b-icon icon="pencil-square" />
                <b-tooltip :target="row.index + 'edit-buttonTipoProblema'" title="Editar..."></b-tooltip>
              </b-button>

            </template>
          </b-table>
          <b-row style="margin-top: 12px" v-if="records && records.length > 0">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
              <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
                totalPage }} -
                {{ total }} registros</b-col>
              <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
                </b-form-select>
              </b-col>
            </b-col>
            <b-col cols="6">
              <div class="d-flex justify-content-end align-items-end">
                <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                  :total-rows="total"></b-pagination>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-card-body>
    </b-card>
    <TipoProblemaForm v-if="showModal" :prefix="prefix + title + ' > '" @close="cancelar" :id="id"></TipoProblemaForm>
  </div>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import TipoProblemaForm from "./TipoProblemaForm.vue";
import ConfirmMixin from "@/core/mixins/confirm"


export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    TipoProblemaForm,
  },
  props: {
    prefix: {
      type: String,
      default: "",
    },

  },

  data() {
    return {
      title: 'Tipo Problema',
      showModal: false,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: 1 },
        { key: "filterSituacao", text: "Inativo", value: 0 },
      ],
      form: {
        descricao: "",
        situacao: 1,
      },
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/tipo-problema`);
  },
  mounted() {
    this.load();
  },
  watch: {
    page() {
      this.load();
    },
  },
  computed: {
    tableFields() {
      return [
        {
          key: "descricao", label: "Descrição",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          thClass: "text-left",

        },
        {
          key: "situacao", label: " ",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          thClass: "text-left",
          tdClass: "w-1",

        },
        {
          key: "action", label: " ", tdClass: "w-1",
          thStyle: "font-size: 16px;",
          tdStyle: "font-size: 13px",
          thClass: "text-left",

        },
      ];
    },
  },
  methods: {
    async load() {

      this.filtro = {};

      if (this.form.descricao) {
        this.filtro.descricao = this.form.descricao;
      }

      this.filtro.situacao = null;
      if (this.form.situacao != null) {
        this.filtro.situacao = this.form.situacao;
      }

      this.busy = true;
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.filtro,
      });
      this.busy = false;
    },
    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Tipo de Problema?",
        item.descricao.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },
    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },


    mostrarModal() {
      this.id = null
      this.showModal = true;
    },
    cancelar() {
      this.showModal = false;
      this.load();
    },

    editar(item) {
      this.id = item.id;
      this.showModal = true;
    },
    async selectItem(item) {
      this.$emit("close", item);
    },
  },

};
</script>
